import axiosClient from "api/apiClient";

export interface IOptions {
    page: string;
    sort?: string;
    order?: string;
    search?: string;
    subject?: string;
    grade?: number | string;
    subcategory?: number | string;
    active_items?: boolean;
    startDate?: string;
    endDate?: string;
    export?: boolean;
    itemTypeId?: string,
}

export const APIGetCustomItems = (options: IOptions) => {
    let sort = "";
    let search = "";
    let exportData = "";
    let dateInterval = "";
    let subject = "";

    if (options.hasOwnProperty("sort")) {
        if(options.order === "asc") {
            sort = "&sort=" + options.sort;
        } else if (options.order === "desc") {
            sort = "&sort=-" + options.sort;
        }
    }

    if (options.hasOwnProperty("search")) {
        search = "&filter[search]=" + options.search;
    }

    if (options.hasOwnProperty("startDate") && options.hasOwnProperty("endDate")) {
        dateInterval = "&start_date=" + options.startDate + "&end_date=" + options.endDate;
    }

    if (options.hasOwnProperty("export")) {
        if (options.export) {
            exportData = "&export=true";
        }
    }

    if (options.hasOwnProperty("subject")) {
        if (options.subject !== undefined) {
            subject = "&subject=" + options.subject;
        }
    }

    return axiosClient.get(`/personalItems${options.page}${search}${sort}${exportData}${subject}${dateInterval}`);
};

export const APIGetCustomItemsAll = (options: IOptions) => {
    let sort = "";
    let search = "";
    let subject = "";
    let grade = "";
    let subcategory = "";

    if (options.hasOwnProperty("sort")) {
        if(options.order === "asc") {
            sort = "&sort=" + options.sort;
        } else if (options.order === "desc") {
            sort = "&sort=-" + options.sort;
        }
    }

    if (options.hasOwnProperty("search")) {
        search = "&filter[search]=" + options.search;
    }

    if(options.hasOwnProperty("subject")) {
        subject = "&subject="+ options.subject;
    }

    if(options.hasOwnProperty("grade")) {
        grade = "&grade="+ options.grade;
    }

    if(options.hasOwnProperty("subcategory")) {
        subcategory = "&subcategory="+ options.subcategory;
    }

    return axiosClient.get(`/personalItems/all${options.page}${search}${sort}${subject}${grade}${subcategory}`);
};

export const APIGetCustomItemsArchived = (options: IOptions) => {
    let sort = "";
    let search = "";
    let subject = "";
    let grade = "";
    let subcategory = "";

    if (options.hasOwnProperty("sort")) {
        if(options.order === "asc") {
            sort = "&sort=" + options.sort;
        } else if (options.order === "desc") {
            sort = "&sort=-" + options.sort;
        }
    }

    if (options.hasOwnProperty("search")) {
        search = "&filter[search]=" + options.search;
    }

    if(options.hasOwnProperty("subject")) {
        subject = "&subject="+ options.subject;
    }

    if(options.hasOwnProperty("grade")) {
        grade = "&grade="+ options.grade;
    }

    if(options.hasOwnProperty("subcategory")) {
        subcategory = "&subcategory="+ options.subcategory;
    }

    return axiosClient.get(`/personalItems/archived/${options.page}${search}${sort}${subject}${grade}${subcategory}`);
};

